// Module helper for capturing a temperature through the offline gateway.
// Online or offline, the SAME durable path + server-authoritative idempotency is used.
// A stable operation_id guarantees a replay creates exactly ONE statutory record.
import { OfflineGateway } from "./gateway";

export const TEMPERATURE_ENDPOINT = "/temperatures/offline-sync";

// data: { venue_id, record_type, item, storage_unit, threshold_name, temperature,
//         minimum, maximum, unit, comments, supplier_id, ... }
// The outbox owns the stable operation_id and the SyncEngine injects it into the POST
// body as `operation_id`, which the server uses for idempotency — so we do NOT set our own.
export async function recordTemperatureOffline(data, gateway = OfflineGateway) {
  const recorded_at_device = data.recorded_at_device || new Date().toISOString();
  return gateway.write({
    entity_type: "temperature",
    action: "create",
    endpoint: TEMPERATURE_ENDPOINT,
    site_id: data.venue_id || null,
    recorded_at_device,
    payload: {
      recorded_at_device,
      device_tz_offset: -new Date().getTimezoneOffset(),
      app_build: (typeof window !== "undefined" && window.__cc_build) || null,
      ...data,
    },
  });
}
